import * as React from 'react'
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import Ret00csModuleLayout from './layouts/Ret00csModuleLayout'
import List from './ret00cs/List'
import New from './ret00cs/New'
import Edit from './ret00cs/Edit'
import Show from './ret00cs/Show'

const CONSOLE_TAB_SESSION_KEY = 'console.tab_session_authorized'

function hasConsoleTabAuthorization(): boolean {
  try {
    return window.sessionStorage.getItem(CONSOLE_TAB_SESSION_KEY) === '1'
  } catch (error) {
    return false
  }
}

export default function RootApp(): JSX.Element {
  const isAuthorized = React.useMemo(() => hasConsoleTabAuthorization(), [])

  React.useEffect(() => {
    if (!isAuthorized) {
      window.location.replace('/init/welcome_do')
    }
  }, [isAuthorized])

  if (!isAuthorized) return <></>

  return (
    <ConfigProvider locale={zhCN}>
      <HashRouter>
        <Routes>
          <Route index element={<Navigate to="/ret00cs" replace />} />
          <Route path="/ret00cs" element={<Ret00csModuleLayout />}>
            <Route index element={<Navigate to="list" replace />} />
            <Route path="list" element={<List />} />
            <Route path="new" element={<New />} />
            <Route path=":id" element={<Show />} />
            <Route path=":id/edit" element={<Edit />} />
          </Route>
          <Route path="*" element={<Navigate to="/ret00cs" replace />} />
        </Routes>
      </HashRouter>
    </ConfigProvider>
  )
}
